import Vue from 'vue'
import Router from 'vue-router'
import cognito from '@/cognito'
import Login from '@/components/Login'
import Form from '@/components/Form'
import Confirmation from '@/components/Confirmation'
import Completion from '@/components/Completion'
import Signup from '@/components/Signup'
import Confirmcode from '@/components/Confirmcode'
import Menu from '@/components/Menu'
import Management from '@/components/Management'
import Destination from '@/components/Destination'
import History from '@/components/History'
import Navigation from '@/components/Navigation'

Vue.use(Router)

const requireAuth = (to, from, next) => {
  cognito.isAuthenticated()
    .then(session => {
      next()
    })
    .catch(session => {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    })
}

const logout = (to, from, next) => {
  cognito.logout()
  next('/')
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Form',
      name: 'Form',
      component: Form,
      beforeEnter: requireAuth
    },
    {
      path: '/Confirmation',
      name: 'Confirmation',
      component: Confirmation,
      beforeEnter: requireAuth
    },
    {
      path: '/Completion',
      name: 'Completion',
      component: Completion,
      beforeEnter: requireAuth
    },
    {
      path: '/Signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/confirmcode',
      name: 'Confirmcode',
      component: Confirmcode
    },
    { path: '/logout',
      beforeEnter: logout
    },
    {
      path: '/Menu',
      name: 'Menu',
      component: Menu,
      beforeEnter: requireAuth
    },
    {
      path: '/Management',
      name: 'management',
      component: Management,
      beforeEnter: requireAuth
    },
    {
      path: '/Destination',
      name: 'destination',
      component: Destination,
      beforeEnter: requireAuth
    },
    {
      path: '/History',
      name: 'history',
      component: History,
      beforeEnter: requireAuth
    },
    {
      path: '/Navigation',
      name: 'navigation',
      component: Navigation,
      beforeEnter: requireAuth
    },
    { path: '/logout',
    beforeEnter: logout
    }

  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js